import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserAddCommentStyles = {
    [key: string]: StylesScene
}

const UserAddCommentStyles: TUserAddCommentStyles = {
    'Group': {
        groupTitleCollection: {
            container: {
                position: 'absolute',
                top: 267,
                left: 16,
                background: '#fff',
                padding: '10px 16px 12px',
                borderRadius: 4,
                zIndex: 2,
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000',
            }
        },
        groupImg: {
            container: {
                position: 'absolute',
                zIndex: 1,
                top: 294,
                left: 0,
                boxSizig: 'border-box',
                width: 280,
                height: 231
            }
        },
        groupCommentImg: {
            container: {
                left: 152,
                top: 89,
                position: 'absolute',
                zIndex: 3,
                width: 330,
                height: 296
            }
        },
        commentText: {
            container: {
                position: 'absolute',
                right: 61,
                top: 484,
                height: 99,
                width: 214,
                zIndex: 3
            },
            text: {
                fontFamily: 'Roboto',
                lineHeight: 1.63,
                fontWeight: 500,
                color: '#21212d',
            }
        },
        mainImg: {
            container: {
                width: 248,
                height: 280,
                position: 'absolute',
                bottom: 0,
                right: 0,
                zIndex: 1,
                boxSizing: 'border-box',
                border: '5px solid #fff'
            }
        },
        commentStaticImgCloud: {
            container: {
                position: 'absolute',
                top: 407,
                right: -5,
                zIndex: 2,
                width: 357,
                height: 215,
            }
        },
        dataTypeTag: {
            container: {
                position: 'absolute',
                bottom: 170,
                left: 15,
            },
            text: {
                opacity: 0.8,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 24,
                fontWeight: 800,
                lineHeight: 2.33,
                letterSpacing: 0.5,
                color: '#ffd288',
            }
        },
        dataTypeTitle: {
            container: {
                position: 'absolute',
                bottom: 137,
                left: 48
            },
            text: {
                opacity: 0.75,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 800,
                lineHeight: 2.8,
                letterSpacing: 0.5,
                color: '#fff',
                textTransform: 'uppercase'
            }
        },
    },
    'Public': {
        docTitle: {
            container: {
                position: 'absolute',
                bottom: 32,
                right: 32,
                padding: '8px',
                borderRadius: 6,
                backdropFilter: 'blur(7px)',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 24,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'right',
                color: '#0e0e14',
            }
        },
        mainImg: {
            container: {
                width: 344,
                height: 433,
                position: 'absolute',
                top: 151,
                right: 67,
                zIndex: 1,
            }
        },
        avatar: {
            container: {
                width: 88,
                height: 88,
                borderRadius: '100%',
                overflow: 'hidden',
                position: 'absolute',
                bottom: 141,
                right: 24,
                objectFit: 'cover'
            }
        },
        dataTypeTitle: {
            container: {
                bottom: 128,
                right: 88,
                position: 'absolute',
            },
            text: {
                fontFamily: 'Roboto Slab',
                textTransform: 'lowercase',
                fontSize: 28,
                opacity: 0.9,
                lineHeight: 2,
                letterSpacing: 1,
                fornWeight: 500,
                color: '#fff',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
            }
        },
        commentText: {
            container: {
                position: 'absolute',
                right: 50,
                top: 471,
                height: 99,
                overflow: 'auto',
                width: 214,
                zIndex: 3
            },
            text: {
                fontFamily: 'Roboto',
                lineHeight: 1.63,
                fontWeight: 500,
                color: '#21212d',
            }
        },
        commentStaticText: {
            container: {
                position: 'absolute',
                left: 17,
                top: 135,
                padding: '11px 27px',
                background: 'linear-gradient(240deg, #edc372 104%, #d7903e 25%)',
                borderRadius: 8,
                textAlign: 'center',
                zIndex: 2,
            },
            text: {
                fontSize: 44,
                lineHeight: 1.32,
                fontWeight: 500,
                color: '#fff',
            }
        },
        commentStaticImgCloud: {
            container: {
                position: 'absolute',
                top: 412,
                right: 6,
                zIndex: 2,
                width: 274,
                height: 196,

            }
        }
    }
}

export const getUserAddCommentBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserAddCommentStyles[notif.groupType]]
}